import { InjectionToken } from '@angular/core';

export interface CargarIngresosRouteContext {
  bandejaPath: string;
  cargaPath: string;
  detalleBasePath: string;
  vistaBasePath: string;
}

export const REAL_CARGAR_INGRESOS_ROUTE_CONTEXT: CargarIngresosRouteContext = {
  bandejaPath: '/cargar-ingresos',
  cargaPath: '/cargar-ingresos/carga',
  detalleBasePath: '/cargar-ingresos/detalle',
  vistaBasePath: '/vista-archivo',
};

export const MOCK_CARGAR_INGRESOS_ROUTE_CONTEXT: CargarIngresosRouteContext = {
  bandejaPath: '/cargar-ingresos-mockup',
  cargaPath: '/cargar-ingresos-mockup/carga',
  detalleBasePath: '/cargar-ingresos-mockup/detalle',
  vistaBasePath: '/vista-archivo-mockup',
};

export const CARGAR_INGRESOS_ROUTE_CONTEXT =
  new InjectionToken<CargarIngresosRouteContext>('CARGAR_INGRESOS_ROUTE_CONTEXT');
